import moment from "moment/moment";
import React, { memo, useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import Select, { components } from "react-select";
import AsyncSelect from "react-select/async";
import toast from "react-hot-toast";
import authService from "../../Services/authService";
import clinicService from "../../Services/clinicService";
import utilFunctions from "../../Utils/utilFunctions";
import validations from "../../Utils/validations";
import "./clinic.css";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ClinicTiming from "./clinicTiming/clinicTiming";
import axios from "axios";
import utils from "../../Utils";
import config from "../../Config/Config";
import Widgets from "../../Widgets";

function ClinicProfile({ setPage, clinicProfileCanvas, isEdited, timeZoneRequired, refresh, hospitalDetails, refreshProfile }) {
  console.log(hospitalDetails);
  const { t } = useTranslation();
  const inputFile = useRef(null);
  const [clinicName, setClinicName] = useState(hospitalDetails.name);
  const [nameErr, setNameErr] = useState("");
  const [phoneErr, setPhoneErr] = useState("");
  const [clinicAddressErr, setClinicAddressErr] = useState("");
  const [clinicAddressErrVi, setClinicAddressErrVi] = useState("");
  const [zipCodeErr, setZipCodeErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [emailID, setEmailID] = useState(hospitalDetails.email);
  const [isUpdateProfilePic, setIsUpdateProfilePic] = useState(false);
  const [profilePic, setProfilePic] = useState(hospitalDetails.hospitalLogo);
  const [profilePicURL, setProfilePicURL] = useState(hospitalDetails.hospitalLogo);
  const [clinicAddress, setClinicAddress] = useState(hospitalDetails.address?.en);
  const [clinicAddressVi, setClinicAddressVi] = useState(hospitalDetails.address?.vi);
  const [zipCode, setZipCode] = useState(hospitalDetails.zipCode);
  const [address, setAddress] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [lat, setLat] = useState(hospitalDetails.geoLocation[0]);
  const [lng, setLng] = useState(hospitalDetails.geoLocation[1]);
  const [locationAddress, setLocationAddress] = useState("");
  const [countryCode, setCountryCode] = useState(hospitalDetails.countryCode);
  const [contactNumber1, setContactNumber1] = useState(hospitalDetails.phoneNumber);
  const [cC, setCC] = useState(false);
  const [timeZone, setTimeZone] = useState("");
  const [countryDropdownOptionPlaceholder, setCountryDropdownOptionPlaceholder] = useState(t("typeToGetCountry"));
  const [isDoctorAdded, setIsDoctorAdded] = useState(false);
  const [timeZoneRequiredValue, setTimeZoneRequiredValue] = useState(false);
  var dt = new Date();
  dt.setDate(dt.getDate());
  const [contactNumberOneErr, setcontactNumberOneErr] = useState("");
  const [clinicTimings, setClinicTimings] = useState(hospitalDetails.openingHoursSpecification);
  const [hospitalDepartments, setHospitalDepartments] = useState(Array.isArray(hospitalDetails.departmentList) ? hospitalDetails.departmentList : []);
  const [availableDepartments, setAvailableDepartments] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [isLoadingDepartments, setIsLoadingDepartments] = useState(false);

  useEffect(() => {
    setCC(true);
    // setCountryCode(authService.getCountryCode());
    if (timeZoneRequired) {
      setTimeZoneRequiredValue(timeZoneRequired);
    } else {
      setTimeZoneRequiredValue(false);
    }
    if (hospitalDetails.hospitalLogo) {
      setIsUpdateProfilePic(true);
    }
    fetchAvailableDepartments();
  }, []);

  const fetchAvailableDepartments = async () => {
    setIsLoadingDepartments(true);
    try {
      const response = await clinicService.getAvailableDepartments();
      console.log("Available departments response:", response);
      if (response && response.status === "success") {
        // The departments are nested under data.departments
        const departments = Array.isArray(response.data?.departments) ? response.data.departments : [];
        setAvailableDepartments(departments);
      } else {
        setAvailableDepartments([]);
      }
    } catch (error) {
      console.error("Error fetching available departments:", error);
      setAvailableDepartments([]);
    } finally {
      setIsLoadingDepartments(false);
    }
  };
  const fetchAddressFromCoordinates = async (lat, lng) => {
    try {
      const response = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`);
      const result = response.data;
      if (result && result.display_name) {
        return { label: result.display_name, value: `${lat},${lng}` };
      } else {
        return { label: "No address found", value: "" };
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      return { label: "Error fetching address", value: "" };
    }
  };

  useEffect(() => {
    const fetchDefaultAddress = async () => {
      const defaultAddress = await fetchAddressFromCoordinates(lat, lng);
      setAddress(defaultAddress);
      setIsLoading(false);
    };
    fetchDefaultAddress();
    setLocationAddress([lat, lng]);
  }, [lat, lng]);

  const handleAddress = (selectedOption) => {
    console.log("Selected address:", selectedOption); // Log the selected option
    setAddress(selectedOption);
    if (selectedOption) {
      const [selectedLat, selectedLng] = selectedOption.value.split(",");
      console.log(`Latitude: ${selectedLat}, Longitude: ${selectedLng}`);
      setLat(parseFloat(selectedLat));
      setLng(parseFloat(selectedLng));
    }
  };

  const getPlaceFromReactGoogleAutocomplete = async (inputValue) => {
    try {
      const response = await axios.get(`https://nominatim.openstreetmap.org/search?q=${inputValue}&format=jsonv2`);
      const options = response.data.map((place) => ({
        label: place.display_name,
        value: `${place.lat},${place.lon}`,
      }));
      return options;
    } catch (error) {
      console.error("Error fetching places:", error);
      return [];
    }
  };
  const handleClinicTimingsChange = (updatedTimings) => {
    setClinicTimings(updatedTimings);
  };

  const handleDepartmentSelection = (selectedOptions) => {
    setSelectedDepartments(selectedOptions || []);
  };

  const removeSelectedDepartment = (departmentId) => {
    setSelectedDepartments(prev => prev.filter(dept => dept._id !== departmentId));
  };
  function NoOptionsMessage(props) {
    return (
      <components.NoOptionsMessage {...props}>
        <span className="custom-css-class">{countryDropdownOptionPlaceholder}</span>
      </components.NoOptionsMessage>
    );
  }

  const ct = require("countries-and-timezones");

  function mobileHandler(e) {
    setCC(true);
    let item = e.target.value;
    item = item.replace(/\s+/g, "");
    let errorMsg = validations.phoneValidator1(item, countryCode, t);
    if (item == "") {
      setContactNumber1(item);
      setPhoneErr(t("mobileNumber"));
    } else {
      if (errorMsg != "") {
      } else {
        setContactNumber1(item);
      }
      let errorMsgs = utilFunctions.checkIsMobileNumberValid(countryCode, item, t);
      setcontactNumberOneErr(errorMsgs);
    }
  }

  function emailHandler(e) {
    let item = e.target.value.trim();
    let errorMsg = validations.emailValidator(item, t);
    if (utils.validations.allValidations.email.test(item)) {
      setEmailID(e.target.value.trim());
    } else {
      setEmailID(e.target.value.trim());
    }
    if (errorMsg != "") {
      setEmailErr(errorMsg);
    } else {
      setEmailErr("");
    }
    setEmailID(e.target.value.trim());
  }

  function nameHandler(e) {
    let item = e.target.value.trimStart();
    let errorMsg = validations.nameValidator(item.trim(), t);
    if (errorMsg.add) {
      setClinicName(item);
    }
    if (errorMsg.message != "") {
      setNameErr(errorMsg.message);
    } else {
      setNameErr("");
    }
    setClinicName(item);
  }

  function clinicHandler(e) {
    let item = e.target.value.trimStart();
    let errorMsg = validations.clinicAddressValidator(item, t);
    console.log(errorMsg);
    if (errorMsg.add) {
      setClinicAddress(item);
    }
    if (errorMsg.message != "") {
      setClinicAddressErr(errorMsg.message);
    } else {
      setClinicAddressErr("");
    }
    setClinicAddress(item);
  }
  function clinicHandlerVi(e) {
    let item = e.target.value.trimStart();
    let errorMsg = validations.clinicAddressValidator(item, t);
    if (errorMsg.add) {
      setClinicAddressVi(item);
    }
    if (errorMsg.message != "") {
      setClinicAddressErrVi(errorMsg.message);
    } else {
      setClinicAddressErrVi("");
    }
    setClinicAddressVi(item);
  }

  function zipCodeHandler(e) {
    let item = e.target.value.trim();
    let errorMsg = validations.zipCodeValidator(item, t);
    if (errorMsg != "") {
      setZipCodeErr(errorMsg);
      setZipCode(item.slice(0, -1));
    } else if (item.length < 4) {
      setZipCodeErr(t("zipCodeErr"));
      setZipCode(item);
    } else {
      setZipCodeErr("");
      setZipCode(item);
    }
  }

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("files", file);
      const jwtToken = authService.getToken();
      try {
        const response = await fetch(config.baseURL + utils.apiName.uploadHospitalMedia, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
          body: formData,
        });
        const result = await response.json();
        // console.log(result);
        if (result.status === "success") {
          const profilePicURLS = result.data.urls[0];
          setProfilePicURL(profilePicURLS);
          const reader = new FileReader();
          reader.onloadend = () => {
            setProfilePic(reader.result);
          };
          reader.readAsDataURL(file);
          // console.log(profilePicURL)
        }
      } catch (error) {
        console.error("Upload error:", error);
        toast.dismiss();
        toast.error(error.message || "An error occurred");
      }
    }
  };

  const clinicProfileSetup = async (e) => {
    setIsLoading(true);
    try {
      let body = {
        name: clinicName,
        openingHoursSpecification: clinicTimings,
        address: clinicAddress,
        address: {
          en: clinicAddress,
          vi: clinicAddressVi,
        },
        zipCode: zipCode,
        geoLocation: locationAddress,
        hospitalLogo: profilePicURL?.replace(/ /g, "%20"),
        phoneNumber: contactNumber1,
        countryCode: countryCode,
      };

      // Update hospital profile first
      let response = await clinicService.updateHospitalProfile(body);

      if (selectedDepartments.length > 0) {
        const departmentIds = selectedDepartments.map(dept => dept._id);
        const departmentResponse = await clinicService.updateHospitalDepartments({
          departmentList: departmentIds
        });
        
        if (departmentResponse && departmentResponse.status === "success") {

          await fetchAvailableDepartments();
          setHospitalDepartments(prev => [...prev, ...selectedDepartments]);
          setSelectedDepartments([]);
        }
      }

      if (response && response.status) {
        toast.dismiss();
        toast.success(t("clinicProfileSuccess"));
        clinicProfileCanvas(false);
        refreshProfile();
        refresh();
      } else if (response.error_code === "10003") {
        toast.dismiss();
        toast.error(t("error_10003"));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  function disableButton() {
    let returnValue = false;
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    let isValid = true;
    for (const day of clinicTimings) {
      if (day.opens !== null && day.closes !== null && (!day.opens || !day.closes || !timeRegex.test(day.opens) || !timeRegex.test(day.closes))) {
        console.log(day.opens);
        isValid = false;
        break;
      }
    }
    if (
      clinicName !== "" &&
      nameErr == "" &&
      clinicAddressErr == "" &&
      clinicAddress != "" &&
      zipCode !== "" &&
      zipCodeErr == "" &&
      locationAddress != "" &&
      emailID &&
      emailErr === "" &&
      clinicAddressVi !== "" &&
      clinicAddress !== "" &&
      isValid
    ) {
      returnValue = false;
      if (timeZoneRequiredValue && !timeZone) {
        returnValue = true;
      }
    } else {
      returnValue = true;
    }
    return returnValue;
  }

  return (
    <div style={{ maxHeight: "90vh" }}>
      {isLoading ? <Widgets.CircularLoader /> : ""}
      <div className="profile-photo">
        <div
          onClick={() => {
            inputFile.current.click();
          }}
          className="profile-icon"
        >
          {profilePic ? <img src={profilePic} className="profile-picture" alt="Profile" /> : <i className="ri-user-add-line profile-icon-logo"></i>}

          <div style={{ visibility: "hidden" }}>
            <input style={{ display: "none" }} type="file" accept=".png,.jpeg,.jpg" onChange={handleImageChange} ref={inputFile} />
          </div>
        </div>
      </div>

      <i
        className="ri-camera-2-line camera-icon"
        onClick={() => {
          inputFile.current.click();
        }}
      />
      <span className="profile-photo-span mt-2">{t("clinicProfilePhoto")}</span>

      <div>
        <div className="profile-form mt-3">
          <div className="input-group input-group-lg">
            <input
              type="text"
              style={{ height: "50px" }}
              className="form-control text-control"
              placeholder={t("clinicNamePlaceHolder")}
              aria-label="Default"
              aria-describedby="inputGroup-sizing-sm"
              maxLength={100}
              value={clinicName.charAt(0).toUpperCase() + clinicName.slice(1)}
              onChange={nameHandler}
            />
          </div>

          <div>
            <span className="d-flex error-container">
              {nameErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
              {nameErr}
            </span>
          </div>
        </div>
        <div className="mt-1">
          <div className="form-group input-group-lg row">
            <div className="code-container">
              <div>
                <PhoneInput
                  inputStyle={{
                    height: "50px",
                  }}
                  value={countryCode}
                  enableSearch={false}
                  countryCodeEditable={false}
                  onChange={(code) => {
                    setCountryCode(code);
                  }}
                />
              </div>
            </div>
            <div className="number-container pe-0 d-flex">
              <input
                type="text"
                style={{ height: "50px" }}
                className="form-control text-control"
                placeholder={t("mobileNumberPlaceholder")}
                aria-label="Large"
                aria-describedby="inputGroup-sizing-sm"
                onChange={(e) => {
                  let val = e.target.value;
                  if (val && val.length > 0) {
                    if (val[0] == 0) {
                      val = val.substring(1);
                      setContactNumber1(val);
                    } else {
                      mobileHandler(e);
                    }
                  } else {
                    mobileHandler(e);
                  }
                }}
                value={contactNumber1}
                // disabled={true}
              />
            </div>
          </div>
          <div>
            <span className="d-flex error-container">
              {phoneErr && phoneErr.length > 0 ? (
                <span className=" contact-number">
                  {" "}
                  <i className="ri-information-line me-1" /> {phoneErr}
                </span>
              ) : (
                contactNumberOneErr &&
                contactNumberOneErr.length > 0 && (
                  <span className="d-flex error-container contact-number">
                    <i className="ri-information-line me-1" />
                    {contactNumberOneErr}
                  </span>
                )
              )}
            </span>
          </div>
        </div>
        <div className="mt-1">
          <div className="input-group input-group-lg">
            <input
              type="text"
              style={{ height: "50px", cursor: "not-allowed" }}
              className="form-control text-control"
              placeholder={t("emailIdPlaceholder")}
              aria-label="Large"
              aria-describedby="inputGroup-sizing-sm"
              value={emailID ? emailID.toLowerCase() : ""}
              onChange={emailHandler}
              disabled={true}
            />
          </div>
          <div>
            <span className="d-flex error-container">
              {emailErr && emailErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
              {emailErr}
            </span>
          </div>
        </div>
        <div className="mt-1">
          <div className="input-group input-group-lg">
            <input
              type="text"
              value={clinicAddress}
              className="form-control text-control"
              placeholder={t("clinicAddressPlaceholder")}
              aria-label="Large"
              aria-describedby="inputGroup-sizing-sm"
              onChange={clinicHandler}
            />
          </div>
          <div>
            <span className="d-flex error-container">{clinicAddressErr}</span>
          </div>
        </div>
        <div className="mt-1">
          <div className="input-group input-group-lg">
            <input
              type="text"
              value={clinicAddressVi}
              className="form-control text-control"
              placeholder={t("clinicAddressPlaceholderVI")}
              aria-label="Large"
              aria-describedby="inputGroup-sizing-sm"
              onChange={clinicHandlerVi}
            />
          </div>
          <div>
            <span className="d-flex error-container">{clinicAddressErrVi}</span>
          </div>
        </div>
        <div className="mt-1">
          <div className="input-group input-group-lg">
            <input
              type="text"
              className="form-control text-control"
              placeholder={t("zipCode")}
              aria-label="Large"
              aria-describedby="inputGroup-sizing-sm"
              maxLength={10}
              min={1}
              value={zipCode}
              onChange={zipCodeHandler}
            />
          </div>

          <div>
            <span className="d-flex error-container">
              {zipCodeErr && zipCodeErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
              {zipCodeErr}
            </span>
          </div>
        </div>
        {/* <div className="mt-1">
                    <AsyncSelect
                        cacheOptions
                        styles={utils.appStyles.selectDropDownPrimary}
                        value={address}
                        onInputChange={(text) => {
                            setCountryDropdownOptionPlaceholder(t("noCountryFound"));
                        }}
                        onFocus={() => {
                            setAddress("");
                            setCountryDropdownOptionPlaceholder(t("typeToGetCountry"));
                        }}
//                         onBlur={(defaultAddress) => {
//     if (!address) {
      
//       setAddress(defaultAddress); 
//     }
//   }}
                        loadOptions={getPlaceFromReactGoogleAutocomplete}
                        onChange={handleAddress}
                        placeholder={t("labelLocationAddress")}
                        components={{ NoOptionsMessage }}
                    />
                </div> */}
        <div className="mt-4">
          <span className="configuration-labels" style={{ margin: "2rem 0" }}>
            {t("departments")}
          </span>
          
          {hospitalDepartments.length > 0 && (
            <div className="mb-3">
              <div className="d-flex flex-wrap gap-2">
                {hospitalDepartments.map((dept) => (
                  <span
                    key={dept._id}
                    className="btn btn-danger btn-depart text-nowrap me-1 mt-1 col-3"
                    style={{ fontSize: "0.875rem", padding: "0.5rem 0.75rem" }}
                  >
                    {dept.departmentName}
                  </span>
                ))}
              </div>
            </div>
          )}

          <div className="mb-3">
            {Array.isArray(availableDepartments) && availableDepartments.length > 0 ? (
              <Select
                isMulti
                options={availableDepartments}
                value={selectedDepartments}
                onChange={handleDepartmentSelection}
                getOptionLabel={(option) => option.departmentName}
                getOptionValue={(option) => option._id}
                placeholder={t("selectDepartments")}
                isLoading={isLoadingDepartments}
                styles={utils.appStyles.selectDropDownPrimary}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            ) : (
              <div className="form-control" style={{ height: "50px", display: "flex", alignItems: "center", padding: "0.375rem 0.75rem" }}>
                {isLoadingDepartments ? t("loadingDepartments") : t("noDepartmentsAvailable")}
              </div>
            )}
          </div>

          {/* {selectedDepartments.length > 0 && (
            <div className="mb-3">
              <small className="text-muted">Selected departments to add:</small>
              <div className="d-flex flex-wrap mt-1">
                {selectedDepartments.map((dept) => (
                  <button
                    key={dept._id}
                    type="button"
                    className="btn btn-success btn-depart text-nowrap me-1 mt-1 col-3 position-relative"
                    onClick={() => removeSelectedDepartment(dept._id)}
                  >
                    <span className="company companyFont">{dept.departmentName}</span>
                    <i className="ri-close-line position-absolute" style={{ top: "2px", right: "4px", fontSize: "0.8rem" }}></i>
                  </button>
                ))}
              </div>
            </div>
          )} */}
        </div>

        <span className="configuration-labels" style={{ margin: "2rem 0" }}>
          {t("labelEditTiming")}
        </span>
        <ClinicTiming clinicTimings={hospitalDetails.openingHoursSpecification} onClinicTimingsChange={handleClinicTimingsChange} />
        {/* {console.log(hospitalDetails)} */}

        <div className="text-end mt-4 pb-4">
          <div className="col-12 d-flex mt-4">
            <button
              className="dialog-btn dialog-btn-type-bordered me-2"
              onClick={() => {
                clinicProfileCanvas(false);
              }}
            >
              {t("btnCancel")}
            </button>
            <button
              type="button"
              className="btn dialog-btn dialog-btn-type-filled"
              disabled={disableButton() || isLoading}
              style={{ backgroundColor: "#DF5551" }}
              onClick={() => {
                clinicProfileSetup();
              }}
            >
              {t("btnSave")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(ClinicProfile);
